import { SequenceTemplate } from "../../types";

export const WELCOME_SEQUENCE_TEMPLATE: SequenceTemplate = {
  id: "welcome-sequence-template",
  name: "Welcome Sequence",
  description: "3-email welcome sequence for new subscribers",
  steps: [
    {
      step_number: 1,
      channel: "email",
      content_template: {
        subject: "🚀 Welcome to Your EVscoop Journey!",
        body: `Dear {FIRST_NAME},

The landscape of electric mobility is transforming faster than ever, and I'm thrilled to welcome you to EVscoop – your strategic partner in navigating this dynamic industry. Having spent years analyzing the intricate developments in the EV sector, from battery technology breakthroughs to market dynamics, I understand how crucial timely, actionable insights are for professionals like you.

The electric revolution is here, and EVscoop is your go-to destination for all the latest in the electric vehicle industry. Whether you're a seasoned EV enthusiast, a newcomer exploring your options, or a business owner looking to tap into the EV market, EVscoop has you covered. We provide detailed insights on the latest electric vehicles hitting the road, in-depth analyses of sustainability initiatives, industry trends, and funding opportunities. From the ambitious targets of the EU Commission to the latest high-performance models electrifying the market, we bring you the stories that are driving change in the world of mobility.

At EVscoop, we believe that staying informed is the key to being part of the change. We aim to be more than just a newsletter—we want to be your community, your resource, and your inspiration as you navigate the rapidly evolving landscape of electric vehicles.

What makes EVscoop different?
• Real-time market intelligence from 100+ verified sources
• Expert analysis of emerging trends and technologies
• Exclusive insights from industry leaders
• Data-driven forecasts and predictions

Your first newsletter arrives tomorrow, packed with actionable insights and exclusive analysis.

Quick Tip: Add newsletter@evscoop.digital to your contacts to never miss an update.

Join the EVscoop Community – Let's Shape the Future of Electric Mobility Together!

What excites me most about having you join our community is the opportunity to share critical insights that could influence your strategic decisions. The EV industry isn't just about vehicles – it's about reshaping our entire approach to mobility, sustainability, and technological innovation. Together, we'll explore these transformations and their implications for your business and our shared future.

Have Your Say!
What aspects of the EV industry interest you most? Reply to this email and let us know—your interests help us tailor our coverage to what matters most to you.

Let's drive the future of mobility together,
The EVscoop Team`,
      },
      delay_hours: 0,
      subject_type: 'dynamic' as const
    },
    {
      step_number: 2,
      channel: "email",
      content_template: {
        subject: "🎯 Customize Your EVscoop Experience",
        body: `Hi {FIRST_NAME},

Let's personalize your EVscoop experience! To ensure you get the most relevant insights, please select your primary area of interest:

Click your preferred topic to customize your experience:

🔋 Battery Technology & Innovation
[https://app.evscoop.digital/preferences?user_id={USER_ID}&category=battery]

🏭 Manufacturing & Supply Chain
[https://app.evscoop.digital/preferences?user_id={USER_ID}&category=manufacturing]

📊 Market Analysis & Trends
[https://app.evscoop.digital/preferences?user_id={USER_ID}&category=market]

📜 Policy & Regulations
[https://app.evscoop.digital/preferences?user_id={USER_ID}&category=policy]

💡 Tech Breakthroughs
[https://app.evscoop.digital/preferences?user_id={USER_ID}&category=tech]

Join the EVscoop Community – Let's Shape the Future of Electric Mobility Together!

Your choice helps us deliver the most relevant content to your inbox. Tomorrow's newsletter will be customized based on your selection.

Have Your Say!
Don't see your area of interest? Reply to this email and let us know what you'd like us to cover!

Let's customize the future of mobility together,
The EVscoop Team`,
      },
      delay_hours: 24,
      subject_type: 'dynamic' as const
    },
    {
      step_number: 3,
      channel: "email",
      content_template: {
        subject: "🔥 Your First EVscoop Briefing Arrives Tomorrow!",
        body: `Hi {FIRST_NAME},

Get ready for your first EVscoop briefing! Here's a preview of tomorrow's coverage:

📈 Market Movements
{PREVIEW_MARKET_CONTENT}

🔬 Innovation Spotlight
{PREVIEW_INNOVATION_CONTENT}

💼 Industry Deals
{PREVIEW_DEALS_CONTENT}

Pro Tips for Getting the Most Value:
1. Set a 10-minute "EVscoop Time" in your calendar
2. Use our mobile-optimized reading mode
3. Save key insights with our one-click save feature

Join the EVscoop Community – Let's Shape the Future of Electric Mobility Together!

We're excited to start delivering valuable insights to your inbox tomorrow.

Have Your Say!
What specific aspects of these topics would you like us to focus on? Your input helps us fine-tune our coverage to your needs.

Let's accelerate the future of mobility together,
The EVscoop Team`,
      },
      delay_hours: 24,
      subject_type: 'dynamic' as const
    }
  ]
};